import React from 'react'

// Components Global
import ModalFixed from '../../../../../components/Modals/ModalFixed'

// Components Products
import SelectProductsList from '../SelectProductsList'


const SelectProductsListModal = (props) => {
  const id = "selectProductsListModal"

  return (
    <ModalFixed
      blockBgModal
      id={id}
      title="เลือกรายการสินค้า"
      width="1200px"
      headerClassName="height-50 line-height-30"
      bodyClassName="top-50 bottom-10 pd-5 bg-efefef"
      footerClassName="height-10 pd-0">


      <SelectProductsList {...props} />

      <div></div>
    </ModalFixed>
  )
}

export default SelectProductsListModal
